import { DiscussionSummary } from "@cnx/common";
import { FC } from "react";
import { ContextDiscussionListItem } from "./ContextDiscussionListItem";
import { PrivateDiscussionListItem } from "./PrivateDiscussionListItem";

interface DiscussionListItemProps {
  discussion: DiscussionSummary;
  currentUserId: string | null | undefined;
  typingMessage?: string;
  onSelect: (discussionId: string, contextId?: string | null) => void;
}

export const DiscussionListItem: FC<DiscussionListItemProps> = ({
  discussion,
  currentUserId,
  typingMessage,
  onSelect,
}) => {
  if (discussion.discussionType === "private") {
    return (
      <PrivateDiscussionListItem
        discussion={discussion}
        currentUserId={currentUserId}
        typingMessage={typingMessage}
        onSelect={onSelect}
      />
    );
  }

  return (
    <ContextDiscussionListItem
      discussion={discussion}
      currentUserId={currentUserId}
      typingMessage={typingMessage}
      onSelect={onSelect}
    />
  );
};
